import { MaestroHistoricTaskProgress, RunLabware } from '../../../types';

export const addLevelsToTasks = (runLabware: RunLabware): RunLabware => {
  const updatedRunLabware: RunLabware = {};

  for (const [labwareId, labwareEntry] of Object.entries(runLabware)) {
    const sortedTasks = [...labwareEntry.tasks].sort(
      (a, b) => a.duration.start - b.duration.start
    );

    const levels: MaestroHistoricTaskProgress[][] = [];

    const updatedTasks: MaestroHistoricTaskProgress[] = sortedTasks.map(
      (task) => {
        for (let i = 0; i < levels.length; i++) {
          const level = levels[i];
          if (!level) continue;

          const overlaps = level.some(
            (t) =>
              t.duration.end > task.duration.start &&
              t.duration.start < task.duration.end
          );

          if (!overlaps) {
            const newTask = { ...task, level: i };
            level.push(newTask);
            return newTask;
          }
        }

        const newTask = { ...task, level: levels.length };
        levels.push([newTask]);
        return newTask;
      }
    );

    updatedRunLabware[labwareId] = {
      ...labwareEntry,
      tasks: updatedTasks,
    };
  }

  return updatedRunLabware;
};
